import { FC, useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import Swal from 'sweetalert2';
import { fetchData, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../../reusable';
import { KTIcon } from '../../../../_metronic/helpers';
import { Tr } from '../../../../_metronic/i18n/Tr';
import { PageTitle } from '../../../../_metronic/layout/core'
import { useLang } from '../../../../_metronic/i18n/Metronici18n';

const ViewLoyaltyProgram: FC = () => {

    const lang = useLang()
    const t = Tr()
    const [basicLevelList, setBasicLevelList] = useState([]);
    const [silverLevelList, setSilverLevelList] = useState([]);
    const [goldLevelList, setGoldLevelList] = useState([]);
    const [platinumLevelList, setPlatinumLevelList] = useState([]);
    const [basicDiscount, setBasicDiscount] = useState('');
    const [silverDiscount, setSilverDiscount] = useState('');
    const [goldDiscount, setGoldDiscount] = useState('');
    const [platinumDiscount, setPlatinumDiscount] = useState('');
    const [buttonDisable, setButtonDisable] = useState(true);

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    // set error state
    const [error, setError] = useState([{
        basicDiscount: '',
        silverDiscount: '',
        goldDiscount: '',
        platinumDiscount: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (!Number.isInteger(Number(basicDiscount))) {
            errorTmp[0].basicDiscount = t('Only Whole Number Are Allowed');
            isValid = false;
        } else if (parseFloat(basicDiscount) <= 0) {
            errorTmp[0].basicDiscount = t('Value Must Be Greater Then 0');
            isValid = false;
        } else if (parseFloat(basicDiscount) > parseFloat(basicLevelList[0]['discountMax'])) {
            errorTmp[0].basicDiscount = t('Value Must Be Less Then Or Equal To Max Discount');
            isValid = false;
        }
        if (!Number.isInteger(Number(silverDiscount))) {
            errorTmp[0].silverDiscount = t('Only Whole Number Are Allowed');
            isValid = false;
        } else if (parseFloat(silverDiscount) <= parseFloat(basicLevelList[0]['discountMax'])) {
            errorTmp[0].silverDiscount = t('Value Must Be Greater Then The Maximum Discount Of Basic');
            isValid = false;
        } else if (parseFloat(silverDiscount) > parseFloat(silverLevelList[0]['discountMax'])) {
            errorTmp[0].silverDiscount = t('Value Must Be Less Then Or Equal To Max Discount');
            isValid = false;
        }
        if (!Number.isInteger(Number(goldDiscount))) {
            errorTmp[0].goldDiscount = t('Only Whole Number Are Allowed');
            isValid = false;
        } else if (parseFloat(goldDiscount) <= parseFloat(silverLevelList[0]['discountMax'])) {
            errorTmp[0].goldDiscount = t('Value Must Be Greater Then The Maximum Discount Of Silver');
            isValid = false;
        } else if (parseFloat(goldDiscount) > parseFloat(goldLevelList[0]['discountMax'])) {
            errorTmp[0].goldDiscount = t('Value Must Be Less Then Or Equal To Max Discount');
            isValid = false;
        }
        if (!Number.isInteger(Number(platinumDiscount))) {
            errorTmp[0].platinumDiscount = t('Only Whole Number Are Allowed');
            isValid = false;
        } else if (parseFloat(platinumDiscount) <= parseFloat(goldLevelList[0]['discountMax'])) {
            errorTmp[0].platinumDiscount = t('Value Must Be Greater Then The Maximum Discount Of Gold');
            isValid = false;
        } else if (parseFloat(platinumDiscount) > parseFloat(platinumLevelList[0]['discountMax'])) {
            errorTmp[0].platinumDiscount = t('Value Must Be Less Then Or Equal To Max Discount');
            isValid = false;
        }

        setError(errorTmp);
        return isValid;
    }

    // Save Promotion & Discount Api Call
    const savePromotionDiscountApiCall = async () => {
        if (validate()) {
            const param = {
                vendorId: vendorId,
                loyaltyDetail: [
                    {
                        discountOffered: parseFloat(basicDiscount) || 0,
                        vendorloyaltyId: basicLevelList[0]['vendorloyaltyId']
                    },
                    {
                        discountOffered: parseFloat(silverDiscount) || 0,
                        vendorloyaltyId: silverLevelList[0]['vendorloyaltyId']
                    },
                    {
                        discountOffered: parseFloat(goldDiscount) || 0,
                        vendorloyaltyId: goldLevelList[0]['vendorloyaltyId']
                    },
                    {
                        discountOffered: parseFloat(platinumDiscount) || 0,
                        vendorloyaltyId: platinumLevelList[0]['vendorloyaltyId']
                    },
                ]
            }

            var res = await fetchData("public/updateVendorLoyalty", param)

            if (res.status == "200") {
                viewVendorLoyalty()
                toastsuccessmsg(t("Loyalty Program Saved Successfully"))
            } else {
                toasterrormsg(res.message)
            }
        }
    }
    // active status api call
    const activeStatusChangeApiCall = async (id: string) => {
        Swal.fire({
            title: t('Are you sure?'),
            text: t('You Want To Join'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('No'),
        }).then(async (result) => {
            if (result.isConfirmed) {

                const param = {
                    vendorloyaltyId: id,
                    status: '1'
                }
                var res = await fetchData("public/statusVendorLoyaltyUpdate", param)
                if (res.status == "200") {
                    viewVendorLoyalty()
                    toastsuccessmsg(t("Join Successfully"))
                } else {
                    toasterrormsg(res.message)
                }
            }
        });
    }
    // inactive status api call
    const inActiveStatusChangeApiCall = async (id: string) => {
        Swal.fire({
            title: t('Are you sure?'),
            text: t('You Want To Cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('No'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                const param = {
                    vendorloyaltyId: id,
                    status: '0'
                }
                var res = await fetchData("public/statusVendorLoyaltyUpdate", param)

                if (res.status == "200") {
                    viewVendorLoyalty()
                    toastsuccessmsg(t("Cancel Successfully"))
                } else {
                    toasterrormsg(res.message)
                }
            }
        });
    }

    // view vendor loyalty api call
    const viewVendorLoyalty = async () => {
        const param = {
            vendorId: vendorId
        }

        var res = await fetchData("public/getVendorLoyalty", param)

        if (res.status == "200") {
            const data = res.data;
            const basicList = data.filter((item: any) => item.level == 'Basic')
            setBasicLevelList(basicList);
            setBasicDiscount(basicList[0]['discountOffered'] != '0' ? basicList[0]['discountOffered'] : '')
            const silverList = data.filter((item: any) => item.level == 'Silver')
            setSilverLevelList(silverList);
            setSilverDiscount(silverList[0]['discountOffered'] != '0' ? silverList[0]['discountOffered'] : '')
            const goldList = data.filter((item: any) => item.level == 'Gold')
            setGoldLevelList(goldList);
            setGoldDiscount(goldList[0]['discountOffered'] != '0' ? goldList[0]['discountOffered'] : '')
            const platinumList = data.filter((item: any) => item.level == 'Platinum')
            setPlatinumLevelList(platinumList);
            setPlatinumDiscount(platinumList[0]['discountOffered'] != '0' ? platinumList[0]['discountOffered'] : '')

            if (basicList[0]['status'] == 1 || silverList[0]['status'] == 1 || goldList[0]['status'] == 1 || platinumList[0]['status'] == 1) {
                setButtonDisable(false)
            }
        }
    }
    useEffect(() => {
        viewVendorLoyalty()
    }, []);
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{t('Loyalty Program')}</PageTitle>
            <div className={`card mb-5 mb-xl-8`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-3 mb-1'>{t('Loyalty Program')}</span>
                        <div className="d-flex bg-light-warning rounded border-warning border border-dashed my-5 p-6">
                            <div className="d-flex flex-stack flex-grow-1">
                                <span className='text-muted mt-1 fw-bold fs-7'>{t("Join our exclusive discount program to attract more customers and boost your business. By offering tiered discounts for loyal customers with recognized levels — Basic, Silver, Gold , and Platinum — you can increase bookings, enhance customer loyalty, and elevate your brand's reputation. Join now to start reaping the benefits of our customer-centric rewards system!")}</span>
                            </div>
                        </div>
                    </h3>
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                        {/* begin::Table */}
                        <table className='table align-middle gs-0 gy-4'>
                            {/* begin::Table head */}
                            <thead>
                                <tr className='fw-bold text-muted bg-light'>
                                    <th className='ps-4 min-w-125px rounded-start'>{t('User Levels')}</th>
                                    <th className='min-w-250px'>{t('Description')}</th>
                                    <th className='min-w-125px'>{t('Discount Max')}</th>
                                    <th className='min-w-250px'>{t('Discount Offered')}</th>
                                    <th className='min-w-50px'>{t('Action')}</th>
                                    <th className='min-w-150px text-center rounded-end'>{t('Status')}</th>
                                </tr>
                            </thead>
                            {/* end::Table head */}
                            {/* begin::Table body */}
                            <tbody>
                                {
                                    basicLevelList.map((basic: any, index: any) => {
                                        var description = getTranslatedValue(lang, basic, '_description')
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='d-flex justify-content-start flex-column'>
                                                            <span className='fw-bold mb-1 fs-6'>
                                                                {t('Basic')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className='fw-semibold d-block mb-1 fs-6'>
                                                        {description}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className='fw-bold d-block mb-1 fs-6'>
                                                        {basic['discountMax']}%
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="input-group mb-1">
                                                        <input type="number" className='form-control' min={1} max={basic['discountMax']} placeholder={t('discount (%)')}
                                                            value={basicDiscount}
                                                            onChange={(e: any) => { setBasicDiscount(e.target.value); removeError('basicDiscount'); }}
                                                            disabled={basic['status'] == '0'}
                                                        />
                                                        <div className="input-group-append border-left-0 rounded-0">
                                                            <span className="input-group-text bg-transparent rounded-0 rounded-end" id="basic-addon2">%</span>
                                                        </div>
                                                    </div>
                                                    <div className='text-danger fw-bold'>{error[0].basicDiscount}</div>
                                                </td>
                                                <td>
                                                    {basic['status'] == '0' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Join"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => activeStatusChangeApiCall(basic['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='entrance-left' className='fs-1' />
                                                        </button>
                                                    )}
                                                    {basic['status'] == '1' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Cancel"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => inActiveStatusChangeApiCall(basic['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='cross' className='fs-1' />
                                                        </button>
                                                    )}
                                                </td>
                                                <td className='text-center'>
                                                    {basic['status'] == '0' && (<span className='badge badge-light-danger fs-7 fw-semibold'>{t('Inactive')}</span>)}
                                                    {basic['status'] == '1' && (<span className='badge badge-light-success fs-7 fw-semibold'>{t('Active')}</span>)}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                {
                                    silverLevelList.map((silver: any, index) => {
                                        var description = getTranslatedValue(lang, silver, '_description')
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='d-flex justify-content-start flex-column'>
                                                            <span className='fw-bold mb-1 fs-6'>
                                                                {t('Silver')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className='fw-semibold d-block mb-1 fs-6'>
                                                        {description}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className='fw-bold d-block mb-1 fs-6'>
                                                        {silver['discountMax']}%
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="input-group mb-1">
                                                        <input type="number" className='form-control' min={basicLevelList[0]['discountMax'] + 1} max={silver['discountMax']} placeholder={t('discount (%)')}
                                                            value={silverDiscount}
                                                            onChange={(e: any) => { setSilverDiscount(e.target.value); removeError('silverDiscount'); }}
                                                            disabled={silver['status'] == '0'}
                                                        />
                                                        <div className="input-group-append border-left-0 rounded-0">
                                                            <span className="input-group-text bg-transparent rounded-0 rounded-end" id="basic-addon2">%</span>
                                                        </div>
                                                        <div className='text-danger fw-bold'>{error[0].silverDiscount}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {silver['status'] == '0' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Join"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => activeStatusChangeApiCall(silver['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='entrance-left' className='fs-1' />
                                                        </button>
                                                    )}
                                                    {silver['status'] == '1' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Cancel"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => inActiveStatusChangeApiCall(silver['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='cross' className='fs-1' />
                                                        </button>
                                                    )}
                                                </td>
                                                <td className='text-center'>
                                                    {silver['status'] == '0' && (<span className='badge badge-light-danger fs-7 fw-semibold'>{t('Inactive')}</span>)}
                                                    {silver['status'] == '1' && (<span className='badge badge-light-success fs-7 fw-semibold'>{t('Active')}</span>)}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                {
                                    goldLevelList.map((gold: any, index: any) => {
                                        var description = getTranslatedValue(lang, gold, '_description')
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='d-flex justify-content-start flex-column'>
                                                            <span className='fw-bold mb-1 fs-6'>
                                                                {t('Gold')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className='fw-semibold d-block mb-1 fs-6'>
                                                        {description}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className='fw-bold d-block mb-1 fs-6'>
                                                        {gold['discountMax']}%
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="input-group mb-1">
                                                        <input type="number" className='form-control' min={silverLevelList[0]['discountMax'] + 1} max={gold['discountMax']} placeholder={t('discount (%)')}
                                                            value={goldDiscount}
                                                            onChange={(e: any) => { setGoldDiscount(e.target.value); removeError('goldDiscount'); }}
                                                            disabled={gold['status'] == '0'}
                                                        />
                                                        <div className="input-group-append border-left-0 rounded-0">
                                                            <span className="input-group-text bg-transparent rounded-0 rounded-end" id="basic-addon2">%</span>
                                                        </div>
                                                        <div className='text-danger fw-bold'>{error[0].goldDiscount}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {gold['status'] == '0' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Join"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => activeStatusChangeApiCall(gold['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='entrance-left' className='fs-1' />
                                                        </button>
                                                    )}
                                                    {gold['status'] == '1' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Cancel"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => inActiveStatusChangeApiCall(gold['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='cross' className='fs-1' />
                                                        </button>
                                                    )}
                                                </td>
                                                <td className='text-center'>
                                                    {gold['status'] == '0' && (<span className='badge badge-light-danger fs-7 fw-semibold'>{t('Inactive')}</span>)}
                                                    {gold['status'] == '1' && (<span className='badge badge-light-success fs-7 fw-semibold'>{t('Active')}</span>)}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                {
                                    platinumLevelList.map((platinum: any, index: any) => {
                                        var description = getTranslatedValue(lang, platinum, '_description')
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='d-flex justify-content-start flex-column'>
                                                            <span className='fw-bold mb-1 fs-6'>
                                                                {t('Platinum')}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className='fw-semibold d-block mb-1 fs-6'>
                                                        {description}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className='fw-bold d-block mb-1 fs-6'>
                                                        {platinum['discountMax']}%
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="input-group mb-1">
                                                        <input type="number" className='form-control' min={goldLevelList[0]['discountMax'] + 1} max={platinum['discountMax']} placeholder={t('discount (%)')}
                                                            value={platinumDiscount}
                                                            onChange={(e: any) => { setPlatinumDiscount(e.target.value); removeError('platinumDiscount'); }}
                                                            disabled={platinum['status'] == '0'}
                                                        />
                                                        <div className="input-group-append border-left-0 rounded-0">
                                                            <span className="input-group-text bg-transparent rounded-0 rounded-end" id="basic-addon2">%</span>
                                                        </div>
                                                        <div className='text-danger fw-bold'>{error[0].platinumDiscount}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {platinum['status'] == '0' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Join"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => activeStatusChangeApiCall(platinum['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='entrance-left' className='fs-1' />
                                                        </button>
                                                    )}
                                                    {platinum['status'] == '1' && (
                                                        <button
                                                            data-toggle="tooltip"
                                                            title="Cancel"
                                                            className='btn btn-icon btn-bg-light btn-active-color-primary me-1'
                                                            onClick={() => inActiveStatusChangeApiCall(platinum['vendorloyaltyId'])}
                                                        >
                                                            <KTIcon iconName='cross' className='fs-1' />
                                                        </button>
                                                    )}
                                                </td>
                                                <td className='text-center'>
                                                    {platinum['status'] == '0' && (<span className='badge badge-light-danger fs-7 fw-semibold'>{t('Inactive')}</span>)}
                                                    {platinum['status'] == '1' && (<span className='badge badge-light-success fs-7 fw-semibold'>{t('Active')}</span>)}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                            {/* end::Table body */}
                        </table>
                        {/* end::Table */}
                    </div>
                    {/* end::Table container */}
                    <div className="row">
                        <div className="col-lg-12 text-end my-5 pe-5">
                            <button className='btn btn-primary' disabled={buttonDisable} onClick={savePromotionDiscountApiCall}>{t('Save')}</button>
                        </div>
                    </div>
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}

export { ViewLoyaltyProgram }